// Time formatting for the dashboard tiles (#1157).

const pad = (n) => String(n).padStart(2, '0');

/**
 * mm:ss countdown (h:mm:ss over an hour); negative ms = overtime, shown
 * with a leading minus. null in, null out.
 */
export function formatCountdown(ms) {
  if (ms == null || !Number.isFinite(ms)) return null;
  const negative = ms < 0;
  const total = Math.abs(Math.round(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const core = h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
  return negative ? `−${core}` : core;
}

/** 'YYYY-MM-DDTHH:MM' wall-clock string (chainSchedule format) → 'HH:MM'. */
export function formatWallClock(value) {
  if (typeof value !== 'string') return null;
  const match = value.match(/T(\d{2}:\d{2})/);
  return match ? match[1] : null;
}
